<template>
  <!-- <v-container grid-list-xs text-xs-center> -->
    <v-layout v-if="selectedBuyer" row wrap>
      <v-flex xs12 sm12>
        <buyer-invoices :isBuyer="isBuyer" :invoices="invoices"/>
      </v-flex>
      <v-flex xs12 sm12>
        <buyer-transactions :buyers="buyers"
              :sellers="sellers"  :invoices="invoices" :isBuyer="isBuyer" header="TRANSACTION OPEN" :status="['due','partial']"/>
      </v-flex>
      <v-flex xs12 sm12>
        <buyer-transactions :buyers="buyers"
              :sellers="sellers"  :invoices="invoices" :isBuyer="isBuyer" header="TRANSACTION CLOSE" :status="['paid']"/>
      </v-flex>
      <v-flex xs12 sm12>
        <buyer-transactions :buyers="buyers"
              :sellers="sellers"  :invoices="invoices" :isBuyer="isBuyer" :header="isBuyer ? 'CREDIT NOTE' : 'DEBIT NOTE'" :status="['due','partial','paid']" :returnedInvoices="true"/>
      </v-flex>
    </v-layout>

  <!-- </v-container> -->
</template>
<script>
import BuyerInvoices from './BuyerInvoices.vue'
import BuyerTransactions from './BuyerTransactions.vue'
import BuyerStatements from './BuyerStatements.vue'

import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']
export default {
  props: ['isBuyer','buyers','sellers'],
  data() {
    return {
    }
  },
  components: {
    BuyerInvoices,
    BuyerTransactions,
    BuyerStatements
  },
  created () {
    // add 'equalTo' filter for tenant filteration
    console.log("invoice is loading")
    this.$bindAsArray(
      'invoices',
      this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  computed: {
    ...mapBuyerGetters(['selectedBuyer']),
    ...mapGlobalGetters(['selectedBrand','brandFinYear']),
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerInvoiceExpansion.vue